export type AuthenticationModesPayload = {
	readonly passwordEnabled: boolean;
	readonly ssoEnabled: boolean;
};

// `email` travels next to `payload`, never inside it: synapse's `DefaultPayload` requires `payload` to
// be a plain record, and this is the address the resolution was performed for — the store needs it to
// tell "these modes belong to the address currently on screen" from "these modes belong to another one".
export type AuthenticationModesResolvedAction = {
	type: 'AUTHENTICATION_MODES_RESOLVED';
	payload: AuthenticationModesPayload;
	email: string;
};

export default (payload: AuthenticationModesPayload, email: string): AuthenticationModesResolvedAction => ({
	type: 'AUTHENTICATION_MODES_RESOLVED',
	payload,
	email,
});
